<template>
  <div class="navbar flex">
    <div class="left-menu">
      <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      <Refresh id="refresh-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      <span class="date-text"><span class="date">{{dateText}}</span><span class="week">{{weekText}}</span>{{timeText}}</span>
    </div>
    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
    <div class="navbar-title">
      {{title}}
    </div>
    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <span class="weather">{{weatherText +' '+ temperature+'℃'}}</span>
        <el-tooltip content="下载任务" effect="dark" placement="bottom" style="z-index: 1;" v-if="isShowDownload">
          <div class="right-menu-item hover-effect" @click="goToDownload">
            <i class="el-icon-download" style="color: #fff;font-size: 16px;"></i>
          </div>
        </el-tooltip>
        <search id="header-search" class="right-menu-item" />
        <el-tooltip content="消息提醒" effect="dark" placement="bottom" style="z-index: 1;">
          <el-badge :value="$store.getters.msgCount.msgNumber>99?'99+':$store.getters.msgCount.msgNumber" class="badge-item" :class="isDeviceAbnormal?'badge-action':''">
            <div class="right-menu-item hover-effect" @click="showMsg">
              <i class="el-icon-message-solid" style="color: #fff;font-size: 16px;"></i>
            </div>
          </el-badge>
        </el-tooltip>
        <el-dropdown class="right-menu-item hover-effect" @command="openWindow" v-if="account != 'yx' || userNameList.indexOf(user.userInfo.userAccount) == -1">
          <div @click="openWindow(3)">
            <svg-icon icon-class="data-big-screen" style="cursor: pointer; font-size: 16px;color:#fff"/>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- 原数据大屏 -->
            <!-- <el-dropdown-item :command="1">数据大屏</el-dropdown-item> -->
            <el-dropdown-item :command="3">智慧大屏</el-dropdown-item>
            <!-- <el-dropdown-item :command="2">营收大屏</el-dropdown-item> -->
            
            <!--            <el-dropdown-item :command="3">测试</el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
        
        <el-tooltip content="全屏缩放" effect="dark" placement="bottom">
          <screenfull id="screenfull" class="right-menu-item hover-effect" />
        </el-tooltip>

        <!-- <el-tooltip content="布局设置" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->

      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!--          <el-image :src="user.userInfo.headIcon ? baseApi + user.userInfo.headIcon : Avatar" class="user-avatar" fit="fill" />-->
          <span style="font-size: 14px; line-height: 2; height: 50px;">{{ user.userInfo.userName }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <span style="display:block;" @click="show = true">
            <el-dropdown-item>
              布局设置
            </el-dropdown-item>
          </span>
          <!--          <router-link to="/user/center">
            <el-dropdown-item>
              个人中心
            </el-dropdown-item>
          </router-link>-->
          <span style="display:block;" @click="updatePassword">
            <el-dropdown-item>
              修改密码
            </el-dropdown-item>
          </span>
          <span style="display:block;" @click="open">
            <el-dropdown-item divided>
              退出登录
            </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    
    <rest-passwd v-if="restParam.visible" :visible.sync="restParam.visible" :param="restParam" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMsgCount } from '@/api/data'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Refresh from '@/components/Refresh'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import Avatar from '@/assets/images/avatar.png'
import restPasswd from './Settings/RestPasswd'
import defaultSettings from '@/settings'
import Cookies from 'js-cookie'
import axios from 'axios'
import dayjs from 'dayjs'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    Refresh,
    Screenfull,
    SizeSelect,
    Search,
    restPasswd
  },
  data() {
    return {
      Avatar: Avatar,
      dialogVisible: false,
      restParam: {
        visible: false,
        title: '重置密码',
        id: ''
      },
      isShowDownload:false,
      isDeviceAbnormal:null,
      account:null,
      dateText:'',
      timeText:'',
      weekText:'',
      weatherText:'',
      temperature:'',
      userNameList:['lfh','zhy','cly','ljh'],
      weatherConf:{
        'yx':'CSeyS',
        'yxjf':'CSeyS',
        'fzmh':'djeOy',
        'sw':'CGyTI',
        'ds':'uDfFU',
        'js':'zeDBq',
        'ct':'CSeyS',
        'rh':'mKDbo',
        'zy':'mKDbo',
        'fa':'JNJhg',
        'mw':'djeOy',
        'lk':'YOyIv',
        'zs':'YIWau',
        'hl':'gDCDS',
        'fsdl':'YOyIv',
        'zt':'cqsJg',
        'hm':'cqsJg',
        'gb':'cqsJg',
        'dl':'cqsJg',
        'ss':'YOyIv'
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device',
      'user',
      'baseApi'
    ]),
    show: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    }
  },
  created(){
    this.account = Cookies.get('account')
    this.title = defaultSettings.moreAccount[this.account]?defaultSettings.moreAccount[this.account].title:'智慧停车管理平台'
    this.getTimeDate();
    this.getCount();
    this.getWeatherData();
    this.$store.getters.user.menuList.forEach(item => {
      if(item.children && !this.isShowDownload){
        item.children.forEach(itemTow => {
          if(itemTow.fullName == '下载任务'){
            this.isShowDownload = true;
          }
        })
      }
    });
    setInterval(()=>{
      this.getCount();
    },60000)
  },
  methods: {
    
    goToDownload() {
      if(this.$route.path != '/OrderManagement/DownloadTask'){
        this.$router.push({ path: '/OrderManagement/DownloadTask'})
      }
      
    },
    showMsg(){
      if(this.$store.getters.msgCount.msgNumber){
        this.$emit('showMsg');
      }else{
        this.$message.error('没有未处理的消息！')
      }
      
    },
    getCount(){
      getMsgCount({status:0}).then(res=>{
        if(res.code == 200){
          if(res.data){
            res.data.deviceOfflineCount = parseInt((res.data.deviceOfflineInCount+res.data.deviceOfflineOutCount).toFixed(0));
            if(this.account == 'mw' && this.$store.getters.user.userInfo.positionIds.length >= 1 && this.$store.getters.user.userInfo.positionIds[0].id ==  '1ac95453b72747e1b101ca5baa00cbe7'){
              res.data.msgNumber = res.data.kaipiaoCount;
            }else{
              res.data.msgNumber = parseInt((res.data.orderAlertcount+res.data.reviewAppealcount+res.data.deviceOfflineInCount+res.data.deviceOfflineOutCount+res.data.kaipiaoCount+res.data.monthlyCardNotRenewalCount).toFixed(0));
              if(res.data.deviceOfflineCount){
                this.isDeviceAbnormal = true;
              }else{
                this.isDeviceAbnormal = false;
              }
            }
            this.$store.dispatch('base/setMsgCount',res.data)
          }else{
            this.$store.dispatch('base/setMsgCount',{
              msgNumber:0,
              deviceOfflineInCount : 0,
              deviceOfflineOutCount : 0,
              deviceOfflineCount : 0,
              orderAlertcount: 0,
              reviewAppealcount: 0,
              kaipiaoCount:0,
              monthlyCardNotRenewalCount:0
            })
            this.isDeviceAbnormal = false;
          }
        }
      })
    },
    getWeatherData(){
      let weatherData = localStorage.getItem(this.account+'WeatherData'); 
      if(weatherData){
        weatherData = JSON.parse(weatherData);
      }
      if(weatherData && (dayjs().format('YYYY-MM-DD') == weatherData.date)){
        this.weatherText = weatherData.data.info;
        this.temperature = weatherData.data.temperature;
      }else{
        axios.get(window.BaseUrl.VUE_APP_BASE_API+`/weather?stationid=${this.weatherConf[this.account]}&_=` + (new Date().getTime()))
        .then(res => {
          if(res.data.data) {
            this.weatherText = res.data.data.real.weather.info;
            this.temperature = res.data.data.real.weather.temperature;
            let wData = {
              date:dayjs().format('YYYY-MM-DD'),
              data:res.data.data.real.weather
            }
            localStorage.removeItem(this.account+'WeatherData');
            localStorage.setItem(this.account+'WeatherData',JSON.stringify(wData))
          }
        })
      }
      
      
      
    },
    getTimeDate(){
      const translateWeekday = {
        Monday: '星期一',
        Tuesday: '星期二',
        Wednesday: '星期三',
        Thursday: '星期四',
        Friday: '星期五',
        Saturday: '星期六',
        Sunday: '星期日',
      };
      setInterval(() => {
        this.dateText = dayjs().format('YYYY-MM-DD');
        this.weekText = translateWeekday[dayjs().locale('zh-cn').format('dddd')];
        this.timeText = dayjs().format('HH:mm:ss');
      }, 1000);
    },
    openWindow(type) {
      let routeData
      if (type === 1) {
        routeData = this.$router.resolve({ path: '/dataView' })
      } else if (type === 2) {
        routeData = this.$router.resolve({ path: '/operationView' })
      } else if (type === 3) {
        routeData = this.$router.resolve({ path: '/newDataView' })
      } else {
        routeData = this.$router.resolve({ path: '/demo' })
      }
      window.open(routeData.href, '_blank')
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    updatePassword() {
      this.restParam.id = this.user.userInfo.userId
      this.restParam.visible = true
    },
    open() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      })
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>

:deep(.el-select .el-input .el-input__inner) {

  background-color: rgba(255, 255, 255, 0);
  border:0px;
  color:#fff;
}
.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  .navbar-title{
    position: absolute;
    left: 50%;
    top:0;
    width: 680px;
    height: 60px;
    background-image: url(~@/assets/images/navbar_header_bg.png);
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-left: -390px;
    font-family: MiSans, MiSans;
    font-weight: bold;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 50px;
    text-shadow: 0px 0px 10px rgba(255,255,255,0.5);
    text-align: center
  }
  .left-menu{
    flex:1;
    height: 38px;
    line-height:42px;
    color:rgba(255,255,255,0.9);
    z-index: 1;
    .date-text{
      font-size:18px;
      margin-left:15px;
      font-weight:bold;
      font-family: 'Time', sans-serif !important;
      letter-spacing:3px;
      .date{
        margin-right:15px;
        font-family: 'Time', sans-serif !important;
      }
      .week{
        margin-right:15px;
        font-family: 'Time', sans-serif !important;
      }
    }
  }
  .hamburger-container {
    width: 38px;
    height: 38px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border:1px solid #78B8FF;
    border-radius: 38px;
    background: linear-gradient( 180deg, #304CB9 0%, #031D8B 100%);
    cursor: pointer;
    float: left;
    margin-right: 10px;
    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    display: flex;
    align-items:center;
    z-index: 1;
    &:focus {
      outline: none;
    }
    .weather{
      color:rgba(255,255,255,.85);
      font-size:18px;
      margin-right:20px;
      font-weight:bold;
      margin-top:5px;
      font-family:'黑体' !important;
    }
    .right-menu-item {
      min-width: 38px;
      height: 38px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      border:1px solid #78B8FF;
      border-radius: 38px;
      background: linear-gradient( 180deg, #304CB9 0%, #031D8B 100%);
      cursor: pointer;
      margin-left: 10px;
      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }

    .avatar-container {
      color: #fff;
      width: auto;
      min-width: 90px;
      padding-left: 20px;
      padding-right: 30px;
      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 8px;
          font-size: 12px;
        }
      }
    }
  }
}

:deep(.el-badge .el-badge__content.is-fixed) {

  top: 5px;
  right: 15px;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3;}
}
:deep(.badge-action .el-badge__content) {

  animation: blink 1s infinite;
}
</style>
